const userAccessPermissionConstant = {
  CAN_ACCESS_AUDITS: "canAccessAudits",
  CAN_ACCESS_COMPLIANCE: "canAccessCompliance",
  CAN_ACCESS_INCIDENTS: "canAccessIncidents",
  CAN_ACCESS_MONITORING: "canAccessMonitoring",
  CAN_ACCESS_RISKASSESSMENTS: "canAccessRiskAssessments",
};

export { userAccessPermissionConstant };
